// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"15":"8bf20b95","263":"e4db1a00","540":"ac91d76a"}[chunkId] + ".js";
};